import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../components/Home.vue'
import Erasmus from '../components/Erasmus.vue'
import VueRouterMetaTags from '@bachdgvn/vue-router-meta-tags';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: `Edoardo.im`,
      metaTags: [
        {
          name: 'og:description',
          content: 'Edoardo Puglisi\'s Personal Portfolio',
        }]
    }
  },
  {
    path: '/erasmus',
    name: 'erasmus',
    component: Erasmus,
    meta: {
      title: `Edoardo.im - Erasmus`,
      metaTags: [
        {
          name: 'og:description',
          content: 'My personal experience during Erasmus project',
        }]
    }
  },
  { path: '/nft01',
    beforeEnter() {
      window.location.href = "https://rarible.com/token/0xd07dc4262bcdbf85190c01c996b4c06a461d2430:332911:0x32aa98a44b0fc7911efdf7b3c4622c561ead351c";
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(VueRouterMetaTags.update);

export default router
